<!-- components/Toast.vue -->
<template>
  <div class="toast-container">
    <transition-group name="toast-fade">
      <div
        v-for="item in toasts"
        :key="item.id"
        class="toast-message"
        :class="item.type"
      >
        <!-- 图标区域：使用背景图或字体图标，此处用 emoji 占位 -->

        <img
          class="toast-icon"
          v-if="item.type === 'success'"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde4.png"
          alt=""
        />
        <img
          class="toast-icon"
          v-else-if="item.type === 'error'"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde5.png"
          alt=""
        />
        <img
          class="toast-icon"
          v-else-if="item.type === 'warning'"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde6.png"
          alt=""
        />
        <img
          class="toast-icon"
          v-else
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-10Popde6.png"
          alt=""
        />

        <span class="toast-text">{{ item.message }} </span>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toasts: [],
      id: 0,
    };
  },
  methods: {
    add(options) {
      const id = this.id++;
      const defaultOptions = {
        message: "",
        type: "info",
        duration: 3000,
      };
      const toast = { ...defaultOptions, ...options, id };
      this.toasts.push(toast);

      if (toast.duration > 0) {
        setTimeout(() => {
          this.remove(id);
        }, toast.duration);
      }
    },
    remove(id) {
      const index = this.toasts.findIndex((item) => item.id === id);
      if (index > -1) {
        this.toasts.splice(index, 1);
      }
    },
    clear() {
      this.toasts = [];
    },
  },
};
</script>

<style  lang="scss" scoped>
@media all and (min-width: 768px) {
  .toast-container {
    position: fixed;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none; /* 让点击穿透 */
    width: 100%;
    max-width: 31.25rem;
  }

  .toast-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    font-weight: 400;
    font-size: 1.1rem;
    color: #101424;
    text-align: left;
    font-style: normal;
    text-transform: none;

    padding: 0.6rem 0.9rem;
    margin-bottom: 0.5rem;
    border-radius: 0.5rem;
    background: #ffffff;
    line-height: 1.5;
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(0.25rem); /* 毛玻璃效果，可选 */
    pointer-events: auto; /* 如果希望可点击，保留 */
    width: fit-content;
    max-width: 100%;
    word-break: break-word;
  }

  /* 图标样式 */
  .toast-icon {
    width: 1.3rem;
    height: 1.3rem;
    flex-shrink: 0;
  }

  /* 文本区域 */
  .toast-text {
    flex: 1;
  }

  /* 不同类型背景色（若需要保留原有区分，可取消注释并调整） */
  /* 
.toast-message.info    { background: #2196F3; }
.toast-message.success { background: #4CAF50; }
.toast-message.error   { background: #F44336; }
.toast-message.warning { background: #FF9800; }
*/

  /* 动画 */
  .toast-fade-enter-active,
  .toast-fade-leave-active {
    transition: opacity 0.3s, transform 0.3s;
  }
  .toast-fade-enter,
  .toast-fade-leave-to {
    opacity: 0;
    transform: translateY(1.25rem);
  }
}

@media (max-width: 767px) {
  .toast-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none; /* 让点击穿透，toast本身不阻挡交互 */
    width: 100%;
    max-width: 42.375rem; /* 与卡片同宽，保持视觉舒适 */
    padding: 0 1rem;
    box-sizing: border-box;
  }

  .toast-message {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20rem;
    max-width: 100%;
    margin-bottom: 1rem;
    padding: 1.5rem 2.5rem;
    background: #ffffff;
    border-radius: 1rem; /* 大圆角，更圆润 */
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(0, 116, 252, 0.1);
    pointer-events: auto; /* 内部可交互（如果需要关闭按钮） */
    transition: all 0.3s ease;

    .toast-icon {
      width: 2rem;
      height: 2rem;
      margin-right: 1.5rem;
      object-fit: contain;
      flex-shrink: 0;
    }

    .toast-text {
      font-size: 1.75rem;
      color: #101424;
      font-weight: 500;
      line-height: 1.4;
      word-break: break-word;
      text-align: left;
    }
  }

  /* 过渡动画 */
  .toast-fade-enter-active,
  .toast-fade-leave-active {
    transition: opacity 0.3s, transform 0.3s;
  }

  .toast-fade-enter-from,
  .toast-fade-leave-to {
    opacity: 0;
    transform: translateY(-1rem);
  }

  .toast-fade-enter-to,
  .toast-fade-leave-from {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>